if (!customElements.get('ecpr-exhaust-media')) {
  customElements.define(
    'ecpr-exhaust-media',
    class EcprExhaustMedia extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.controls = Array.from(this.querySelectorAll('[data-ecpr-sound-control]'));
        this.audios = Array.from(this.querySelectorAll('[data-ecpr-audio]'));
        this.status = this.querySelector('[data-ecpr-sound-status]');

        this.controls.forEach((control) => {
          const audio = this.querySelector(`#${control.dataset.audioId}`);
          if (!audio) return;

          control.addEventListener('click', () => this.toggleAudio(control, audio));
          audio.addEventListener('play', () => this.updateControl(control, audio, true));
          audio.addEventListener('pause', () => this.updateControl(control, audio, false));
          audio.addEventListener('timeupdate', () => this.updateProgress(control, audio));
          audio.addEventListener('ended', () => this.finishAudio(control, audio));
        });
      }

      toggleAudio(control, audio) {
        if (!audio.paused) {
          audio.pause();
          return;
        }

        this.audios.forEach((otherAudio) => {
          if (otherAudio !== audio) this.resetAudio(otherAudio);
        });

        const playRequest = audio.play();
        if (playRequest !== undefined) {
          playRequest.catch(() => {
            this.updateControl(control, audio, false);
            this.announce('Sound could not be played. Please try again.');
          });
        }
      }

      resetAudio(audio) {
        audio.pause();
        audio.currentTime = 0;

        const control = this.controls.find((item) => item.dataset.audioId === audio.id);
        if (control) {
          this.updateControl(control, audio, false);
          this.updateProgress(control, audio);
        }
      }

      finishAudio(control, audio) {
        audio.currentTime = 0;
        this.updateControl(control, audio, false);
        this.updateProgress(control, audio);
        this.announce(`${control.dataset.soundLabel} sound finished.`);
      }

      updateControl(control, audio, isPlaying) {
        control.classList.toggle('is-playing', isPlaying);
        control.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');

        const action = control.querySelector('[data-ecpr-sound-action]');
        if (action) action.textContent = isPlaying ? 'Pause sound' : 'Play sound';

        if (isPlaying) this.announce(`Playing ${control.dataset.soundLabel} sound.`);
      }

      updateProgress(control, audio) {
        const progress = control.querySelector('[data-ecpr-sound-progress]');
        if (!progress) return;

        const percentage = Number.isFinite(audio.duration) && audio.duration > 0
          ? Math.min(audio.currentTime / audio.duration, 1)
          : 0;
        progress.style.transform = `scaleX(${percentage})`;
      }

      announce(message) {
        if (this.status) this.status.textContent = message;
      }
    }
  );
}
